export const profileKeys = {
  all: ["profile"] as const,
  // Keyed by user id so a different signed-in user refetches their own profile
  // (and never reads the previous user's cached row).
  current: (userId: string | null | undefined) =>
    [...profileKeys.all, "current", userId ?? "anon"] as const,
  // All profiles — admin Users page (BF-215).
  list: () => [...profileKeys.all, "list"] as const,
};
